import { render, staticRenderFns } from "./Model22.vue?vue&type=template&id=7be77f84&scoped=true"
import script from "./Model22.vue?vue&type=script&lang=js"
export * from "./Model22.vue?vue&type=script&lang=js"
import style0 from "./Model22.vue?vue&type=style&index=0&id=7be77f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be77f84",
  null
  
)

export default component.exports